import { Component } from '@angular/core';
import {
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFormBuilderComponent,
  FormBuilder,
} from '@controladad/ng-base';

export interface DetailsDialogData<T, U> {
  formBuilder: FormBuilder<T, U>;
  value?: Partial<T>;
  itemName?: string,
}

export type DetailsDialogResult = never;

@Component({
  selector: 'app-details-dialog',
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent],
  templateUrl: './details-dialog.component.html',
})
export class DetailsDialogComponent<T, U> extends CacBaseDialogComponent<DetailsDialogData<T, U>, DetailsDialogResult> {
  constructor() {
    super();
    this.data.formBuilder.reset(this.data.value);
    this.data.formBuilder.setReadonly(true);
  }
}
